import React from 'react';
import { Link } from '@paypalcorp/pp-react';
export default ({ publicCredential, handleClickChange = () => { }, labelForChange = '' }) => {
    return (React.createElement("div", { style: { marginBottom: '30px', textAlign: 'center' } },
        publicCredential,
        React.createElement(Link, { href: "#", className: "secondaryLink", id: "linkChangeEmail", "data-testid": "link-change-email", onClick: handleClickChange, style: { marginLeft: '5px' }, tabIndex: "1" }, labelForChange)));
};
